import axios from "axios";
const currentLang = document.documentElement.lang;
const lang = "pl";

const URL = process.env.REACT_APP_API_URL;
const newURL = `${URL}/material/?lang=${lang}`;

interface IDensities {
  name: string;
  default: boolean;
  density: number;
}

export interface IMaterialResponse {
  name: string;
  slug: string;
  default: boolean;
  densities: IDensities[];
}

export const materialTypeService = () => {
  return axios.get<IMaterialResponse[]>(newURL);
};
